module.exports = __webpack_public_path__ + "img/14.1f55ff1a.png";